import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { resolvePriceOpen } from '@ecp/common/src/utils/good/goodUtil';
import useGoodOptionItem from '@ecp/common/src/hooks/good/option/useGoodOptionItem';
//import theme from '@ecp/common/src/style/theme/default';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { DropdownItemWrapper } from '@ecp/common/src/components/unstyled/dropdown/DropdownDefaultComponent';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import SubGoodDropDownItem from '@fo-pages/good/SubGoodDropDownItem';

const GoodOptionItem = ({ label, subGoodIndex, leafItem }) => {
  const { isPriceOpen: siteIsPriceOpen, priceFormat } = useSiteInfo();
  // REQ_DS_05_01
  const isPriceOpen = resolvePriceOpen(leafItem?.priceExpsUseYn, siteIsPriceOpen);

  const { disabled, labelWithSalePossibleQuantity, discountPrice } = useGoodOptionItem({
    leafItem,
    label,
    priceFormat,
  });

  return (
    <GoodOptionItemWrapper disabled={disabled}>
      <SubGoodDropDownItem
        width={discountPrice ? 'calc(100% - 100px)' : '100%'}
        subGoodIndex={subGoodIndex}
        label={labelWithSalePossibleQuantity}
        padding={'0px'}
      />
      {isPriceOpen && <TextBox flex-shrink={'0'}>{discountPrice}</TextBox>}
    </GoodOptionItemWrapper>
  );
};

const GoodOptionItemWrapper = styled(DropdownItemWrapper)`
  justify-content: space-between;
  height: 40px;
  padding: 0 10px;
  font-size: ${(props) => props.theme.font.size.basic};
  font-weight: ${(props) => props.theme.font.weight.demiLight};

  &:hover {
    background-color: ${(props) => props.theme.color.background.sub};
  }
`;

GoodOptionItem.propTypes = {
  label: PropTypes.string,
  subGoodIndex: PropTypes.string,
  leafItem: PropTypes.object,
};

export default GoodOptionItem;
